// Table of contents:
// 1 eInvoice
import { EInvoices } from '../../../data'
import { getTranslationsForConfig } from '../getTranslationsForConfig'

export const createEInvoices = (): EInvoices => {
  return {
    // 1 eInvoice
    eInvoice: {
      enabled: true,
      table: {
        enabled: true,
        columns: [
          {
            // Test und Herkunft
            field: 'Meta',
            header: getTranslationsForConfig(
              'eInvoiceOverview.table.columns.testAndSource.header',
            ), // i18n.t('eInvoiceOverview.table.columns.testAndSource.header')
          },
          {
            // Rechnungsnummer
            field: 'Payload.ID.Value.Value',
            header: getTranslationsForConfig(
              'eInvoiceOverview.table.columns.invoiceNumber.header',
            ), // i18n.t('eInvoiceOverview.table.columns.invoiceNumber.header')
          },
          {
            // Rechnungsart
            field: 'Payload.InvoiceTypeCode.Value',
            header: getTranslationsForConfig(
              'eInvoiceOverview.table.columns.invoiceType.header',
            ), // i18n.t('eInvoiceOverview.table.columns.invoiceType.header')
          },
          {
            // BT-45
            field: 'Payload.AccountingCustomerParty.Party.PartyName.Name.Value',
            header: getTranslationsForConfig(
              'eInvoiceOverview.table.columns.recipientTradeName.header',
            ), // i18n.t('eInvoiceOverview.table.columns.recipientTradeName.header')
          },
          {
            // Rechnungsdatum
            field: 'Payload.IssueDate.Value',
            header: getTranslationsForConfig(
              'eInvoiceOverview.table.columns.invoiceDate.header',
            ), // i18n.t('eInvoiceOverview.table.columns.invoiceDate.header')
          },
          {
            // Gesamtbetrag
            field: 'Payload.LegalMonetaryTotal.PayableAmount.Value.Value',
            header: getTranslationsForConfig(
              'eInvoiceOverview.table.columns.grossPrice.header',
            ), // i18n.t('eInvoiceOverview.table.columns.grossPrice.header')
          },
          {
            // Dokument
            field: 'Meta.file.fileName',
            header: getTranslationsForConfig(
              'eInvoiceOverview.table.columns.documentName.header',
            ), // i18n.t('eInvoiceOverview.table.columns.documentName.header')
          },
          {
            // Angelegt von
            field: 'Meta.file.uploadedBy',
            header: getTranslationsForConfig(
              'eInvoiceOverview.table.columns.createdBy.header',
            ), // i18n.t('eInvoiceOverview.table.columns.createdBy.header')
          },
          {
            // Angelegt am
            field: 'Meta.file.uploadedAt',
            header: getTranslationsForConfig(
              'eInvoiceOverview.table.columns.createdAt.header',
            ), // i18n.t('eInvoiceOverview.table.columns.createdAt.header')
          },
          {
            // Status
            field: 'Meta.file.status',
            header: getTranslationsForConfig(
              'eInvoiceOverview.table.columns.status.header',
            ), // i18n.t('eInvoiceOverview.table.columns.status.header')
          },
        ],
        emptyMessageDetails: getTranslationsForConfig(
          'eInvoiceOverview.table.emptyMessageDetails',
        ), // i18n.t('eInvoiceOverview.table.emptyMessageDetails')
        emptyMessageTitle: getTranslationsForConfig(
          'eInvoiceOverview.table.emptyMessageTitle',
        ), // i18n.t('eInvoiceOverview.table.emptyMessageTitle')
        paginator: true,
        rows: 5,
        rowsPerPageOptions: [5, 20, 50],
        sortField: 'Payload.InvoiceDate',
        sortOrder: -1,
      },
    },
  }
}
